const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+SKU+Detail+API

function getReverseLookUpSkuDetails(skuId) {
    const url = `/api/catalog/skus/${skuId}`;

    return ufeApi.makeRequest(url, { method: 'GET' }).then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = getReverseLookUpSkuDetails;
